module.exports = __webpack_public_path__ + "static/media/clutch_logo.5ea81d7e.png";